import React,{Component} from 'react';

//----Include Fragment Pages-----
import HeaderSection from '../websiteFolder/web_fragment/header';
import FooterPage from '../websiteFolder/web_fragment/footer';
//----End Include Fragment Pages-----

export default class termConditionPagePanel extends Component{
    constructor(props){
        super(props);
        this.state = {
            isLoaded : false,
            isLoggedin : false
        }
    }

    async componentDidMount(){
        this.setState({isLoaded:true});
    }

    render(){
        
        return(
            <div id="page-wrapper">
                <React.Fragment>
                    <div id="main" className="mainSectionWebsite">
                        <section className="header">
                            <div className="container">
                                <HeaderSection />
                                {/* <!-- Banner --> */}
                                <div className="row">
                                    <div className="col-lg-12">
                                        <h1 className="txt-style-6">Terms & Conditions</h1>
                                    </div>
                                </div>
                            </div>
                        </section>
                        
                        <section className="sec4 sec4C">
                            <div className="container">
                                <div className="row">
                                    <div className="col-lg-12">
                                        <div className="blog_content">
                                            <div className="blog_txt blog_txt1">
											   <p>
												  Welcome to Vyavsay. By accessing or using our website (<a href="https://www.vyavsay.in/">www.vyavsay.in</a>) and services, you agree to comply with and be bound by the following terms and conditions. Please read them carefully before using the site.
											   </p>
                         <br/>
											   <h3>1. Acceptance of Terms</h3>
											   <p>
												  By accessing this site or using any of our services or mobile applications, you confirm that you have read, understood, and agree to these Terms & Conditions, along with our Privacy Policy and any other legal notices or policies displayed.
											   </p>
                         <br/>
											   <h3>2. Use of Website and Services</h3>
											   <p>The content and services provided on this website are for informational and business use only.</p>
											   <p>You agree not to misuse the site in any way, including but not limited to unauthorized access, data scraping, transmitting harmful content, or disrupting the website’s operation.</p>
											   <p>You must be at least 18 years old to use our services or represent an entity legally able to enter into agreements.</p>
                         <br/>
											   <h3>3. Account Responsibility</h3>
											   <p>When you create an account with Vyavsay, you are responsible for maintaining the confidentiality of your login credentials.</p>
											   <p>Any activity occurring under your account will be deemed your responsibility.</p>
											   <p>You agree to notify us immediately of any unauthorized use or security breach.</p>
                         <br/>
											   <h3>4. Intellectual Property Rights</h3>
											   <p>All content on Vyavsay’s website, including but not limited to text, graphics, logos, icons, and software, is the property of Vyavsay or its content suppliers and is protected under applicable copyright and intellectual property laws.</p>
											   <p>You may not reproduce, modify, or distribute any content without explicit written permission from Vyavsay.</p>
                         <br/>
											   <h3>5. Software Licensing</h3>
											   <p>Vyavsay grants you a limited, non-transferable license to use the software for your personal or internal business use.</p>
											   <p>You may not resell, decompile, reverse-engineer, or exploit any part of the software.</p>
                         <br/>
											   <h3>6. Taxes & Compliance</h3>
											   <p>Vyavsay provides tools to assist with managing taxes but is not responsible for your tax filings or compliance.</p>
											   <p>Users must ensure they adhere to applicable tax regulations under local, state, or national law.</p>
                         <br/>
											   <h3>7. Limitation of Liability</h3>
											   <p>Vyavsay is not liable for any direct, indirect, or incidental damages arising from your use of the website or software.</p>
											   <p>We make no guarantees that the service will be uninterrupted or error-free, though we strive to offer high-quality and reliable support.</p>
                         <br/>
											   <h3>8. Modifications to Terms</h3>
											   <p>We reserve the right to update or change these terms at any time. Continued use of the site after such changes indicates your acceptance of the revised terms.</p>
                         <br/>
											   <h3>9. Termination</h3>
											   <p>Vyavsay reserves the right to suspend or terminate your account or access to the site at any time if there is a violation of these terms.</p>
                         <br/>
											   <h3>10. Governing Law</h3>
											   <p>These terms are governed by the laws of India. Any disputes shall be resolved in the courts located in [Insert Jurisdiction, e.g., Indore, Madhya Pradesh].</p>
                         <br/>
											   <h3>11. Contact Us</h3>
											   <p>For any questions regarding these Terms & Conditions, you may reach us at.</p>
											   <p><b>Email:</b> contact@vyavsay.in</p>
											   <p><b>Website:</b> www.vyavsay.in</p>
											</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>

                        {/* Footer Code Here */}
                        <FooterPage />
                    </div>
                </React.Fragment>                
            </div>
        )
    }
}